/* src/app/features/empresas-bloqueadas/envio-consulta-protocolo-empresa/envio-consulta-protocolo-empresa.component.scss */
.botoes {
  display: flex;
  justify-content: right;
  align-items: center;
}
.botoes {
  margin: 4px;
}
/*# sourceMappingURL=envio-consulta-protocolo-empresa.component.css.map */
